/** Actions */
export const ON_FETCH_REPO = 'ON_FETCH_REPO';
export const ON_FETCH_REPO_SUCCESS = 'ON_FETCH_REPO_SUCCESS';
export const ON_FETCH_REPO_FAILURE = 'ON_FETCH_REPO_FAILURE';
/** Action creators */

export function onFetchRepo() {
  return { type: ON_FETCH_REPO };
}

export function onFetchRepoSuccess(repoDetails: any) {
  return { type: ON_FETCH_REPO_SUCCESS, repoDetails };
}

export function onFetchRepoFailure() {
  return { type: ON_FETCH_REPO_FAILURE };
}
